// extracted by mini-css-extract-plugin
module.exports = {"grid":"_3YPMdYm_lYUvvXfO8Min3-","list":"_3ZYrTJeFrrmBbGvFnNuPdk","center":"_1nvPWgQ1P8BunYlCNthbu8"};